module.exports = __webpack_public_path__ + "img/product_39.ab5ea71.webp";